import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 微信绑定服务
 */
export class WechatAuthControllerSvr {
    constructor() {
        this.baseurl = 'WechatAuthControllerSvr.assx/';
    }

    /**
     * 解除绑定
     * token:String, openId:String
     */
    WechatUnBind(token, openId){
        return request.post(this.baseurl + 'WechatUnBind', Qs.stringify({ token:token, openId:openId }));
    }

    /**
     * 判断绑定
     * token:String
     */
    CheckBindSuccess(token){
        return request.post(this.baseurl + 'CheckBindSuccess', Qs.stringify({ token:token }));
    }

    /**
     * 获取登录微信Url
     * token:String
     */
    GetLoginCode(token){
        return request.post(this.baseurl + 'GetLoginCode', Qs.stringify({ token:token }));
    }
}